import axios from "axios";
import { useMutation } from "react-query";
import { DetailedServiceBookingData } from "../../../../components/ServiceManagement/OrderRequests/Domain/RemoteOrderRequests.types";

/**
 * GET the detail information of the selected order request
 */
export const useRemoteFetchOrderRequestDetail = () => {
  return useMutation({
    mutationFn: async (bookingId: string | number) => {
      const response = await axios.get<DetailedServiceBookingData>(
        `/service-booking/service-bookings/${Number(bookingId)}`
      );
      return response.data;
    }
  });
};
